module.exports = __webpack_public_path__ + "media/3.8b8ef864.mp3";